var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsmLogoHorizontalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 367.4 98.7",
    style: {
      enableBackground: "new 0 0 367.4 98.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,40c30.2-25.7,40.3-29,43.5-26.4c3.8,3.1-1.2,14.8,2.2,16.4c4.5,2.1,19.6-14.9,25.2-14 c0.5,0,0.9,0.2,1.3,0.5c2.2,1.7-0.3,6.3,1.6,8.6c1.2,1.5,3.7,1.2,5.2,1.1c8.2-0.8,16.2-7.5,19.5-10.5c-17.1,18.6-24,21.6-26.9,20 c-2.5-1.5-1.8-6.3-4.9-7.3c-2.9-1-5.1,2.6-11.2,5.8c-1.3,0.7-11.9,6.1-16.8,2.5c-3.9-3-0.8-9.5-3.7-12.1S34.7,23.5,11.3,40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,65.1C37.1,40.6,47.4,37,50.2,39.6c3.1,2.8-3,13,0.3,15.3c5,3.5,23.6-17,28.5-13.2c2.4,1.8-0.8,7.8,1.7,10 c3.3,2.9,13.5-3.2,24-10.9C87.5,59.7,80.4,63,77.4,61.2c-2.6-1.5-1.7-6.7-4.9-7.8s-5.7,3.7-13.4,7.1c-1.8,0.8-11.1,4.9-15.2,1.4 c-3.8-3.2-0.1-9.8-2.8-12.4S29.9,48.7,6.1,65.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,82.9c16.1-15.6,23.3-18,26.6-16C51,69,49.9,76.2,53.5,77c2.9,0.7,4.8-3.8,12.8-8.2 c3.1-1.7,8.1-4.5,10.3-2.8c2.5,1.9-0.7,7.6,1.1,9.2c2,1.9,10.2-2,31.4-19.3c-2.6,3.5-19.4,25.2-30.1,27.2c-1.6,0.3-5.5,1.1-7.5-1 s-0.3-5.1-1.6-6c-3-2-13.4,12.9-20.1,10.4c-2.5-0.9-4-4.1-4.4-5c-1.9-4-0.4-6.7-1.5-8C42.5,72.1,37.5,72.7,20.7,82.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.7,56l-5.6-21.6L126.4,56h-5.5l-8.3-29.2h5.7l5.7,22.4l6-22.4h4.1l6,22.4l5.7-22.4h5.7L143.2,56H137.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.1,56v-2.3c-1.6,1.8-4.1,2.8-6.9,2.8c-3.4,0-7.3-2.4-7.3-7c0-4.9,3.8-6.9,7.3-6.9c2.9,0,5.3,0.9,6.9,2.7 v-3.1c0-2.4-2.1-3.9-4.9-3.9c-2.4,0-4.5,0.9-6.3,2.7l-1.9-3.2c2.4-2.4,5.5-3.4,8.9-3.4c4.7,0,8.8,2,8.8,7.6v14H166.1z M166.1,51.1 v-3.2c-1.1-1.4-3.1-2.2-5-2.2c-2.6,0-4.5,1.5-4.5,3.8c0,2.3,2,3.8,4.5,3.8C163.1,53.3,165,52.6,166.1,51.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.1,51V38.8h-3.5v-4h3.5v-5.8h4.6v5.8h4.3v4h-4.3v11.1c0,1.4,0.7,2.5,2,2.5c0.9,0,1.7-0.4,2-0.8l1.1,3.5 c-0.8,0.7-2.2,1.4-4.3,1.4C178.9,56.5,177.1,54.6,177.1,51z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.8,45.4c0-6.1,4.5-11.1,10.7-11.1c6.3,0,10.4,4.8,10.4,11.5v1.1h-16.3c0.3,3.1,2.7,5.8,6.7,5.8 c2.1,0,4.5-0.8,6-2.4l2.1,3c-2.1,2-5.2,3.1-8.6,3.1C192.5,56.5,187.8,52.1,187.8,45.4z M198.5,38.1c-3.9,0-5.7,3-5.9,5.6h11.9 C204.3,41.1,202.6,38.1,198.5,38.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,56V34.8h4.6v3.1c1.6-2,4.2-3.6,6.9-3.6v4.5c-0.4-0.1-0.8-0.1-1.4-0.1c-2,0-4.5,1.3-5.5,2.8V56H213z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.7,51.8l2.9-4c2,2.1,5.2,4.1,9.2,4.1c4.2,0,5.8-2.1,5.8-4c0-6.1-17-2.3-17-13c0-4.9,4.2-8.6,10.6-8.6 c4.5,0,8.2,1.5,10.9,4.1l-2.9,3.8c-2.3-2.3-5.4-3.4-8.5-3.4c-3,0-4.9,1.5-4.9,3.6c0,5.5,17,2.1,17,12.9c0,4.9-3.5,9.1-11.3,9.1 C244.2,56.5,240.3,54.6,237.7,51.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.6,51V38.8h-3.5v-4h3.5v-5.8h4.6v5.8h4.3v4h-4.3v11.1c0,1.4,0.7,2.5,2,2.5c0.9,0,1.7-0.4,2-0.8l1.1,3.5 c-0.8,0.7-2.2,1.4-4.3,1.4C267.4,56.5,265.6,54.6,265.6,51z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.2,56V34.8h4.6v3.1c1.6-2,4.2-3.6,6.9-3.6v4.5c-0.4-0.1-0.8-0.1-1.4-0.1c-2,0-4.5,1.3-5.5,2.8V56H278.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.3,45.4c0-6.1,4.5-11.1,10.7-11.1c6.3,0,10.4,4.8,10.4,11.5v1.1h-16.3c0.3,3.1,2.7,5.8,6.7,5.8 c2.1,0,4.5-0.8,6-2.4l2.1,3c-2.1,2-5.2,3.1-8.6,3.1C296,56.5,291.3,52.1,291.3,45.4z M302,38.1c-3.9,0-5.7,3-5.9,5.6H308 C307.9,41.1,306.2,38.1,302,38.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.4,45.4c0-6.1,4.5-11.1,10.7-11.1c6.3,0,10.4,4.8,10.4,11.5v1.1h-16.3c0.3,3.1,2.7,5.8,6.7,5.8 c2.1,0,4.5-0.8,6-2.4l2.1,3c-2.1,2-5.2,3.1-8.6,3.1C320,56.5,315.4,52.1,315.4,45.4z M326,38.1c-3.9,0-5.7,3-5.9,5.6H332 C331.9,41.1,330.2,38.1,326,38.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,51V38.8H338v-4h3.5v-5.8h4.6v5.8h4.3v4h-4.3v11.1c0,1.4,0.7,2.5,2,2.5c0.9,0,1.7-0.4,2-0.8l1.1,3.5 c-0.8,0.7-2.2,1.4-4.3,1.4C343.3,56.5,341.5,54.6,341.5,51z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.4,81.3v-16h7.5c3.5,0,5.4,2.4,5.4,5.2c0,2.8-1.9,5.1-5.4,5.1h-4.1v5.7H128.4z M137.8,70.4 c0-1.3-1-2.2-2.4-2.2h-3.6v4.3h3.6C136.7,72.5,137.8,71.7,137.8,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.6,81.3l-3.1-5.7H154v5.7h-3.4v-16h7.5c3.3,0,5.4,2.2,5.4,5.2c0,2.8-1.8,4.3-3.5,4.8l3.6,6.1H159.6z  M160,70.4c0-1.3-1-2.1-2.4-2.1H154v4.3h3.6C158.9,72.6,160,71.8,160,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.5,73.3c0-4.8,3.5-8.3,8.4-8.3c4.8,0,8.4,3.5,8.4,8.3c0,4.8-3.5,8.3-8.4,8.3 C176,81.5,172.5,78.1,172.5,73.3z M185.7,73.3c0-3-1.9-5.3-4.8-5.3c-3,0-4.9,2.3-4.9,5.3c0,3,1.9,5.3,4.9,5.3 C183.8,78.5,185.7,76.2,185.7,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.8,81.3v-16h7.5c3.5,0,5.4,2.4,5.4,5.2c0,2.8-1.9,5.1-5.4,5.1h-4.1v5.7H198.8z M208.2,70.4 c0-1.3-1-2.2-2.4-2.2h-3.6v4.3h3.6C207.1,72.5,208.2,71.7,208.2,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221,81.3v-16h11.3v3h-7.9v3.4h7.8v3h-7.8v3.6h7.9v3H221z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.2,81.3l-3.1-5.7h-2.5v5.7h-3.4v-16h7.5c3.3,0,5.4,2.2,5.4,5.2c0,2.8-1.8,4.3-3.5,4.8l3.6,6.1H251.2z  M251.6,70.4c0-1.3-1-2.1-2.4-2.1h-3.6v4.3h3.6C250.5,72.6,251.6,71.8,251.6,70.4z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.3,81.3v-13h-4.7v-3h12.8v3h-4.7v13H268.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.7,81.3v-16h3.4v16H285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.5,81.3v-16h11.3v3h-7.9v3.4h7.8v3h-7.8v3.6h7.9v3H299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.6,79l1.9-2.7c1.1,1.2,2.9,2.2,5.1,2.2c1.9,0,2.8-0.8,2.8-1.8c0-2.8-9.2-0.8-9.2-6.9 c0-2.7,2.3-4.9,6.1-4.9c2.5,0,4.7,0.8,6.2,2.2l-1.9,2.5c-1.3-1.2-3-1.8-4.7-1.8c-1.4,0-2.3,0.6-2.3,1.6c0,2.5,9.2,0.8,9.2,6.8 c0,2.9-2.1,5.1-6.4,5.1C323.3,81.5,321.1,80.5,319.6,79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsmLogoHorizontalWhite);
export default __webpack_public_path__ + "static/media/wsm-logo-horizontal-white.3c7d5db2969a70ed2fb9bf78ca246fc6.svg";
export { ForwardRef as ReactComponent };